
import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import AbpBase from '@/lib/abpbase';

@Component
export default class GenderRadios extends AbpBase{
    @Prop({type:String, default:""}) value:String;
    @Prop({type:Boolean, default:false}) disabled: Boolean;
    
    get newValue(){
        return this.value;
    }
    set newValue(value:String){
        this.$emit('input',value);
    }

    change(item:any) {
        this.$emit("on-change", item);
    }

    created(){
    }
}
